import styles from '@styles/components/mobile/Sidebar.module.css';
import { useRef, useState } from 'react';
import { LeftMenuOption } from '@shared/designSystem/LeftMenuOption';

import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';

// import {ReactComponent as FrecuenciaSVG} from '@assets/SVGs/Sidebar/Frecuencia/Frecuencia.svg'
// import {ReactComponent as FrecuenciaSVGClicked} from '@assets/SVGs/Sidebar/Frecuencia/FrecuenciaClicked.svg'

// import {ReactComponent as ColaboradoresSVG} from '@assets/SVGs/Sidebar/Colaboradores/Colaboradores.svg'
// import {ReactComponent as ColaboradoresSVGClicked} from '@assets/SVGs/Sidebar/Colaboradores/ColaboradoresClicked.svg'

// import {ReactComponent as ResumenSVG} from '@assets/SVGs/Sidebar/Resumen/Resumen.svg'
// import {ReactComponent as ResumenSVGClicked} from '@assets/SVGs/Sidebar/Resumen/ResumenClicked.svg'

// import {ReactComponent as MapSVG} from '@assets/SVGs/Sidebar/Mapa/Mapa.svg'
// import {ReactComponent as MapSVGClicked} from '@assets/SVGs/Sidebar/Mapa/MapaClicked.svg'

// import {ReactComponent as QontactPointsSVG} from '@assets/SVGs/Sidebar/QontactPoints/QontactPoint.svg'
// import {ReactComponent as QontactPointsSVGClicked} from '@assets/SVGs/Sidebar/QontactPoints/QontactPointClicked.svg'

// import {ReactComponent as PlaneSVG} from '@assets/SVGs/Sidebar/Novedades/PlaneSVG.svg'
// import {ReactComponent as PlaneSVGClicked} from '@assets/SVGs/Sidebar/Novedades/PlaneClickedSVG.svg'

// import {ReactComponent as ConfigSVG} from '@assets/SVGs/Sidebar/Configuracion/Configuracion.svg'
// import {ReactComponent as ConfigSVGClicked} from '@assets/SVGs/Sidebar/Configuracion/ConfiguracionClicked.svg'


import { ReactComponent as LogOutLogo } from '@assets/SVGs/Sidebar/Logout.svg';
import { ReactComponent as OrgSVG } from '@assets/SVGs/Sidebar/OrgSVG.svg';

import { useAuth } from '@contexts/authContext';


const MobileSidebar = ({defaultOrg, setOrg, clickedID, setClickedID, isClosing, handleHamburgerClose}) => {

    const {logOut, orgs, user} = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const dropdownRef = useRef(null);

    const handleDropdownClick = () => {
        setIsDropdownOpen(!isDropdownOpen);
    
        if (dropdownRef.current) {
            dropdownRef.current.scrollTop = 0;
        }
    };

    const handleDropdownOptionClick = (org) => {
        handleDropdownClick()
        setOrg(org)
    }

    const handleClick = (id) => {
        setClickedID(id)
        handleHamburgerClose()
    }

    return (
        <div className={`${styles.sidebar} ${isClosing && styles['slide-out']}`} onClick={(e) => {
            e.stopPropagation();
        }}>
            <div className={styles['qontact-container']}>
                <QontactBackgroundSVG style={{pointerEvents: 'none'}} viewBox={"0 0 700 305"} className={styles['qontact-background']}/>

                <div className={styles['qontact-actions']}>
                    <div className={styles['qontact-text-container']}>
                        <QontactTextSVG/>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={handleHamburgerClose}>
                        <path d="M1 1L14.8993 14.8993" stroke="#FEAFA2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 14.8984L14.8993 0.999142" stroke="#FEAFA2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            {user && 
            <div className={styles['dropdown-container']}>
                <div className={styles['dropdown']} onClick={handleDropdownClick}>
                    <div style={{display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}>
                        <div className={styles['svg-container']} style={{width: '30px', marginRight: '5px'}}>
                            <OrgSVG/>
                        </div>

                        <p className={styles['dropdown-text']}>{defaultOrg ? orgs.find(org => org.id === defaultOrg.id)?.name ?? defaultOrg.name : "Seleccionar organización"}</p>
                    </div>

                    <div className={styles['svg-container']} style={{marginRight: '0px', height: '30px'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" style={{ 
                            transform: isDropdownOpen ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.2s ease'
                        }}>
                            <path d="M1 1L7 7L13 1" stroke="#666666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div ref={dropdownRef} className={styles['dropdown-expanded-container']} 
                style={{
                    overflowY: isDropdownOpen ? 'auto' : 'hidden', 
                    height: isDropdownOpen ? '200px' : '0', 
                    transition: 'height 0.2s ease-out',
                    pointerEvents: isDropdownOpen ? 'auto' : 'none',
                    opacity: isDropdownOpen ? '1' : '0'
                }}>
                    {orgs.filter(org => org.id !== defaultOrg?.id).map((org) => {
                        return (
                            <div key={org.id} className={styles['dropdown-option']} onClick={() => {handleDropdownOptionClick(org)}}>
                                <div style={{display: "flex", flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%', height: '100%'}}>
                                    <div className={styles['svg-container']} style={{minWidth: '22.1px', marginRight: '5px'}}>
                                        <OrgSVG/>
                                    </div>

                                    <p className={styles['dropdown-text']}>{org.name}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            }
            <div className={styles['item-list']} style={!user ? {marginTop: '100px'} : {}}>
                {defaultOrg && (
                <>
                    {defaultOrg.flags?.hasPresenteeismTable && (
                    <LeftMenuOption
                        label="Listado"
                        icon="listado"
                        isActive={clickedID === "Listado"}
                        onClick={() => handleClick("Listado")}
                    />
                    )}
                </>
                )}
            </div>
            <div className={styles['logout-container']} onClick={logOut} style={{justifySelf: 'flex-end'}}>
                <div className={styles['svg-container']}>
                    <LogOutLogo/>
                </div>
                <p className={styles['logout-text']}>
                        Cerrar Sesión
                </p>
            </div>
        </div>
    );
}

export default MobileSidebar;
